import React from "react";
import { observer, inject } from "mobx-react";

@inject("store")
@observer
export default class Logout extends React.Component {

	constructor(props) {
		super(props);
	}
	
	componentDidMount() {
		this.props.store.account.Logout();
	}

	render() {

		return (<div>
			<h1 className="text-muted text-normal text-uppercase">Loggar ut..</h1>
			{/*<div className="text-sm">*/}
			{/*	<button className="btn btn-primary"*/}
			{/*		onClick={() => {*/}
			{/*			this.props.store.account.Logout();*/}
			{/*		}}*/}
			{/*	>Yes</button>*/}
			{/*	<button className="btn btn-secondary"*/}
			{/*		onClick={() => {*/}
			{/*			this.props.store.navigation.closeToolbar();*/}
			{/*		}}*/}
			{/*	>Cancel</button></div>*/}
		</div>);

	}
}